import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useGetBankPaymentParsersQuery } from '@widgets/AddPayments/lib/hooks/useGetBankPaymentParsersQuery';
import { useImportCompanyPaymentsQuery } from '@widgets/AddPayments/lib/hooks/useImportCompanyPaymentsQuery';

import { fetchAccounts, fetchPaymentsForEdit } from '../../../../store/slices/paymentSlice/action';

export const useAddPayments = () => {
    const dispatch = useDispatch();
    const { pagination, filter, isLoadingFilters, isLoadingDataForEdit } = useSelector(
        (state) => state.paymentReducer
    );
    const { t } = useTranslation();
    const [isShowImportPopup, setIsShowImportPopup] = useState(null);
    const [isShowImport, setIsShowImport] = useState(false);
    const { data, isLoading, isFetching } = useGetBankPaymentParsersQuery();

    const onClickImport = () => {
        setIsShowImport(true);
    };

    const onHideImportModal = () => {
        setIsShowImport(false);
    };

    const exportQuery = Object.entries(filter)
        .filter(([key, value]) => value !== null && key !== 'page')
        .map(([key, value]) => (key === 'page' ? `page=${value}` : value))
        .join('');

    const exportUrl = `${routable.getRoute('exportCompanyPaymentsReact')}?${exportQuery}`;
    const importUrl = routable.getRoute('importCompanyPaymentsReact');

    const [modalState, setModalState] = useState({
        isOpen: false,
        mode: 'debit',
        step: 1,
        isBetweenAccount: false,
        isOpenPartners: false,
    });
    const accountsSelectList = useSelector((state) => state.paymentReducer.accountsSelectList);

    const [partnerData, setPartnerData] = useState([]);
    const onSwitcherChange = () => {
        setModalState((prevState) => ({
            ...prevState,
            isBetweenAccount: !prevState.isBetweenAccount,
        }));
    };
    const onHideModal = () => {
        const newState = { ...modalState, isOpen: false };
        setModalState(newState);
    };

    const onHideModalPartner = () => {
        const newState = { ...modalState, isOpenPartners: false };
        setModalState(newState);
    };

    const buttonsHandler = async (mode) => {
        if (accountsSelectList.length) {
            setModalState((prevState) => ({
                ...prevState,
                mode,
                isOpen: true,
                step: 1,
                isBetweenAccount: mode === 'transfer',
            }));
        } else {
            loader.show();
            const callback = () => {
                setModalState((prevState) => ({
                    ...prevState,
                    mode,
                    isOpen: true,
                    step: 1,
                    isBetweenAccount: mode === 'transfer',
                }));
                loader.hide();
            };
            dispatch(fetchAccounts());

            callback();
        }
    };

    const contextValue = {
        modalState,
        setModalState,
        onHideModal,
        onSwitcherChange,
        accountsSelectList,
        setPartnerData,
        onHideModalPartner,
    };

    const { mutateAsync, isPending } = useImportCompanyPaymentsQuery();

    const hidePopup = () => {
        setIsShowImportPopup(null);
        // loader.show();
        dispatch(fetchPaymentsForEdit(pagination.current));
    };

    const handleSubmitImport = async (account, bank, file) => {
        const res = await mutateAsync({
            account,
            bank,
            file,
        });

        if (res.status !== 'error') {
            setIsShowImport(false);
            setIsShowImportPopup(res.data?.data?.message);
        }
    };

    const isLoadingAddPayments =
        isLoading || isFetching || isLoadingFilters || isLoadingDataForEdit;

    return {
        t,
        isShowImportPopup,
        isShowImport,
        data,
        onClickImport,
        onHideImportModal,
        partnerData,
        onHideModal,
        onHideModalPartner,
        buttonsHandler,
        contextValue,
        hidePopup,
        handleSubmitImport,
        isPending,
        modalState,
        setModalState,
        onSwitcherChange,
        dispatch,
        filter,
        pagination,
        isLoadingAddPayments,
        exportUrl,
    };
};
